<script setup>
import i18n from '@/lang/i18n';

const props = defineProps({
  carNumber: String,
})
</script>

<template>
  <div class="d-flex justify-center mt-3 mx-10" style="border: black solid 1px;">
    <div class="d-flex justify-center w-50 py-3 title">
      {{ i18n.global.t('pages.temperatureSensors.charts.chartTitle') }}
    </div>
    <div class="d-flex justify-center w-50 py-3" style="font-weight: bold;">{{ props.carNumber }}</div>
  </div>
</template>

<style>
  .title {
    background-color: black;
    color: white;
    font-weight: bold;
    border: 0px
  }
</style>